<template>
  <div>
    <div class="flight-school-details-container">
      <!-- tabs -->
      <div class="flight-school-details-tabs">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          :class="['flight-school-details-tab', { active: activeTab === index }]"
          @click="activeTab = index"
        >
          {{ tab }}
        </div>
      </div>

      <AirlineDashboardHeader :name="school?.name || ''" :subInfo="subInfo" />

      <div class="cadets-table">
        <div class="cadets-table-header">
          <div
            class="grid px-3 gap-sm mb-3 align-items-center"
            :style="$global.dynamicColsV2(0.6, 1, 1, 1, 1, 1)"
          >
            <h2>All Cadets</h2>
            <HiloSelect
              v-for="(item, index) in filter.items"
              :key="index"
              :options="[]"
              v-model="filter[item.prop]"
              :placeholder="item.placeholder"
              theme="grey"
              :customStyle="{
                backgroundColor: '#e4e4e2',
                height: '35px',
              }"
            />
          </div>
        </div>
        <HiloTableV2 :columns="columns" :data="cadets" :hasDot="true">
          ...
          <template #gradeBook="{ item }">
            <img
              src="/static/img/attachment.svg"
              @click="
                $router.push({ path: `/hilo/flight-school/lender-gradebook/${item.id}` })
              "
            />
          </template>
        </HiloTableV2>
      </div>
    </div>

    <ToastNotifier ref="toast" />
  </div>
</template>
<script>
import dayjs from "dayjs";
import HiloSelect from "../../../components/HiloComponents/HiloSelect.vue";
import ToastNotifier from "../../../components/ToastNotifier.vue";
import ActiveStudentsAPIService from "../../../servicehandlers/ActiveStudentsAPIService.js";
import FlightSchoolsAPIService from "../../../servicehandlers/FlightSchoolsAPIService.js";
import AirlineDashboardHeader from "./AirlineDashboardHeader.vue";
import HiloTableV2 from "./HiloTableV2.vue";
import { getProcessedImageUrl } from "../../../util/images.js";
const flightSchoolsAPIService = new FlightSchoolsAPIService();

const studentAPIService = new ActiveStudentsAPIService();
export default {
  name: "FlightSchoolDetails",
  components: { AirlineDashboardHeader, HiloTableV2, HiloSelect, ToastNotifier },
  props: ["id"],
  data() {
    return {
      school: null,
      tabs: ["All Students Cadets", "All Instructor Cadets"],
      activeTab: 0,
      subInfo: {
        left: "150 Student Cadets",
        right: "65 Instructor Cadets",
      },
      filter: {
        items: [
          { placeholder: "Grades", prop: "grade" },
          { placeholder: "Status", prop: "status" },
          { placeholder: "Hours", prop: "hours" },
          { placeholder: "All Schools", prop: "school" },
          { placeholder: "Program", prop: "program" },
        ],
      },
      columns: [
        { name: "Name", value: "name" },
        { name: "Grade", value: "grade", align: "center" },
        { name: "Status", value: "status" },
        { name: "Hr", value: "hr", align: "center" },
        { name: "Program", value: "program", align: "center" },
        { name: "Start", value: "start", align: "center" },
        { name: "End", value: "end", align: "center" },
        { name: "Balance", value: "balance", align: "center" },
        { name: "Link", value: "link", isUrl: true, align: "center" },
        {
          name: "Grade Book",
          align: "center",
          customRender: { slotScope: "gradeBook" },
        },
        { name: "Log Book", value: "logBook", isUrl: true, align: "center" },
      ],
      cadets: [],
    };
  },
  async mounted() {
    await this.getSchool();
    await this.getStudentDetails();
  },
  methods: {
    async getSchool() {
      try {
        this.school = await flightSchoolsAPIService.getFlightSchoolById(
          this.id,
          this.$router
        );
      } catch (error) {
        this.$refs.toast.showError("Unable to get school");
      }
    },
    async getStudentDetails() {
      try {
        this.cadets = await studentAPIService.getAllStudentDetails(this.$router);
        for (let student of this.cadets) {
          if (student.details.class) {
            student.details.class.startDate = dayjs(student.details.class.startDate);
            student.details.class.endDate = dayjs(student.details.class.endDate);
          }
          student.user.image = getProcessedImageUrl(student.user.image);
          student.name = this.$global.getFullName(student.user);
        }
      } catch (error) {
        this.$refs.toast.showError("Unable to get student details");
      }
    },
  },
};
</script>
<style>
.flight-school-details-container {
  padding: 10px 35px;
  display: flex;
  flex-direction: column;
  gap: 60px;
}
.flight-school-details-tabs {
  display: flex;
  font-size: 14px;
}
.flight-school-details-tab {
  cursor: pointer;
  padding: 10px 20px;
  border-bottom: 2px solid #cfcfcf;
  color: #404040;
}
.flight-school-details-tab.active {
  border-bottom: 2px solid #3c78ff;
}
.cadets-table-header h2 {
  font-weight: bold;
  color: #404040;
  margin: unset;
}
.gap-sm {
  gap: 10px;
}
</style>
